import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar38Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar38 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar38Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar38">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M228.12 132.441c0-51.288-9.764-79.807-50.921-79.807-74.304 0-81.568 26.241-82.237 77.521-.047 3.815.104 7.542.415 11.182-11.373 6.076-8.068 16.835-2.708 29.403 4.253 9.979 11.54 16.764 18.134 17.688.39.645.804 1.274 1.21 1.911l-11.109 47.577s24.425 11.978 44.263 26.154c19.839 14.175 39.167 35.415 39.167 35.415s-1.824-19.129 1.012-33.305c1.6-8.004 3.496-17.879 4.842-24.959.43.016.868.032 1.29.032 19.599-1.195 22.442-21.583 36.093-67.941-.239-9.979-2.78-13.818-2.883-23.605-.04-4.261 3.432-12.137 3.432-17.274v.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M141.536 136.59s7.956-2.628 21.495-2.54c7.525.048 16.875 4.356 20.212 4.754 5.256.638 5.304-8.011 5.304-8.011.255-1.338-13.634-6.021-26.377-5.973-11.173.047-13.284 3.257-20.634 11.763v.007Z"
            fill="#000"
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_2"
              d="M179.333 147.341c-15.195-9.095-27.149-4.141-30.382-.661-.446.486-.502 1.354-.112 1.951.231.359.566.534.892.518.223-.016.382-.167.613-.311 1.322-.78 3.289-1.449 5.615-1.927.048 3.656 2.978 6.61 6.602 6.61s6.602-2.994 6.602-6.69c0-.079 0-.159-.008-.238 3.106.469 6.148 1.353 8.784 2.795.622.342 1.123.478 1.506-.088.382-.565.485-1.6-.12-1.967l.008.008Z"
            />
            <Path
              id="Vector_3"
              d="M224.84 148.839c-2.342-2.509-11.214-8.012-18.445-2.389a.15.15 0 0 0-.064.016c-.016.024-.024.047-.032.063a13.964 13.964 0 0 0-1.744 1.641c-.358.398-.406 1.083-.103 1.521.302.438.828.478 1.187.088.342 2.715 2.795 4.826 5.773 4.826 3.21 0 5.814-2.453 5.814-5.471 0-.94-.255-1.832-.709-2.605 3.329.837 6.109 2.804 7.208 3.982.143.152.31.231.485.239.263.016.526-.119.709-.39.311-.462.271-1.139-.079-1.513v-.008Z"
            />
          </G>
          <Path
            id="Vector_4"
            d="M205.694 136.709c0 .94 1.417 2.183 2.413 2.055 4.627-.557 3.241-.772 14.47-1.186 1.434-.056 4.182.151 4.182.151s3.042-5.949.414-8.012c-1.617-1.266-15.092.566-17.521 1.904-3.791 2.086-3.95 2.843-3.958 5.081v.007Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="m206.02 134.368 3.042 4.468s-5.893 5.702-5.607 11.883c.287 6.18 6.372 27.38 6.372 27.38s1.234 3.424-1.139 4.85c-2.373 1.425-4.946 3.99-10.075 3.711-5.136-.287-7.223-2.286-9.604-1.999-2.381.287-4.468 0-4.468-1.808s5.511-2.373 8.553-2.19c3.043.191 3.329 1.139 6.563.948 3.233-.191 6.371-.287 6.371-3.52 0-3.234-7.51-20.914-6.467-27.763 1.043-6.849 2.835-13.236 6.467-15.975l-.008.015Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_6"
            d="M189.909 212.694h14.869c1.218 0 1.999 1.291 1.441 2.374-.844 1.648-3.026 3.552-8.609 3.552s-7.9-1.784-9.047-3.393c-.757-1.059.048-2.533 1.346-2.533Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_7"
            d="M118.146 199.06c3.806 12.615 9.357 26.225 17.027 34.707 17.488 19.336 30.685 29.458 42.655 34.062 1.967.756 4.364 1.226 6.976 1.497.159-1.067.335-2.119.542-3.138 1.6-8.004 3.496-17.879 4.842-24.959-21.169-.589-51.352-15.514-72.042-42.169Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_8"
            d="M196.089 270.863c-1.704-.74-5.567-2.19-10.855-4.101-2.676 14.112-.9 32.732-.9 32.732s-19.328-21.24-39.166-35.416c-19.839-14.168-44.264-26.154-44.264-26.154l.095-.398c-7.621-2.604-12.463-4.245-12.463-4.245s9.07 18.787-1.944 26.568c-6.928 4.89-18.213 10.29-25.628 13.626 25.334 18.963 56.791 30.192 90.877 30.192 22.156 0 43.197-4.747 62.175-13.276-5.814-8.506-12.75-17.274-17.919-19.528h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_9"
            d="M207.486 195.205c-4.707 0-8.092 1.474-8.092 1.474s-4.117-1.8-9.126-1.8c-5.002 0-9.565 1.633-14.28 2.047-2.516.215-9.198-1.091-11.285-1.171-.581-.024-.756.549-.215.701 4.994 1.362 19.456 7.327 33.425 7.327 7.789 0 13.133-3.512 17.457-4.357.932-.183 1.25-1.003.581-1.505-1.831-1.362-5.24-2.716-8.465-2.716Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="hair"
            d="m121.085 154.071-7.311 1.418s-5.814-20.093-14.726-15.729c-8.912 4.356-10.6 8.243-10.6 8.243s-4.34-3.775-3.591-6.555c.748-2.779-3.322-2.779-3.322-4.985 0-2.206 2.183-4.794 2.183-4.794s-4.46.668-4.46-3.075c0-3.743 2.469-6.522 2.469-6.522s-5.13-1.442-5.225-6.045c-.095-4.603 4.651-6.044 4.651-6.044s-4.937-.669-4.65-5.95c.286-5.28 4.746-6.522 4.746-6.522s-2.947-18.389 7.86-24.672c-1.49-5.894.526-6.826 2.788-9.032 2.261-2.206 9.556-1.186 9.556-1.186s-1.505-3.982 3.186-8.984c4.691-5.001 9.557.343 9.557.343s.677-6.435 6.889-8.402c6.212-1.967 8.155 1.609 8.155 1.609s-.534-5.368 5.837-5.902c6.371-.533 9.908 2.684 9.908 2.684s5.128-6.26 10.265-6.076c5.129.175 5.662 5.009 5.662 5.009s2.095-4.508 7.622-4.508c5.527 0 8.864 5.583 8.864 5.583s.342-4.189 6.22-3.377c5.877.813 6.562 7.558 6.562 7.558s4.006-5.097 9.047-3.01c5.041 2.086 5.957 8.8 5.957 8.8s5.272-3.472 8.251-.924c2.978 2.549 2.748 10.417 2.748 10.417s5.726.462 9.397 3.472c3.663 3.01 3.209 11.81 3.209 11.81s5.958 3.242 5.958 8.57-4.357 9.398-4.357 9.398 4.81 1.02 4.357 4.491c-.454 3.473-5.042 5.559-5.042 5.559s2.063 2.318 1.601 5.559c-.462 3.241-5.495 6.252-5.495 6.252s-2.979-23.382-6.419-26.162c-3.44-2.78-21.081-10.879-40.33-8.57-19.249 2.31-47.425 12.87-47.425 12.87s7.104 10.513 1.601 20.476c-5.495 9.955-13.061 10.417-13.292 13.658-.231 3.242 1.139 23.247 1.139 23.247Z"
            fill={c.hair}
          />
        </G>
      </G>
    </Svg>
  );
};
